import React from "react";
import { useFormik } from "formik";
import { CloseIcon } from "../../../../assets/icons";
import { handleKeyDown } from "../../../../utils/OtherFunctions";
import { NuDate } from "../../../../utils/Inputs";
import FormikSelectTwo from "../../../../utils/Select";
import { CancelButton, SubmitButton } from "../../../../utils/Button";

function FilterModal({ statusValue, onSubmit, initialValues, onClose }) {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    onSubmit: (values) => {
      onSubmit(values);
    },
  });

  return (
    <div id="modal" className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm flex justify-center items-center">
      <div className="bg-white mt-12 p-2 rounded-xl w-6/12">
        <div className="flex items-start justify-between px-5 py-2 rounded-t">
          <h3 className="text-base 2xl:text-lg font-semibold">Filter</h3>
          <span className="h-6 w-6 text-2xl block cursor-pointer" onClick={onClose} aria-label="Close filter modal">
            <CloseIcon />
          </span>
        </div>
        <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
          <div className="w-full max-h-[70vh] overflow-y-auto relative px-6 flex flex-wrap justify-between">
            <NuDate formik={formik} name="completion_start_date" label="Completion Start Date" width="w-1/2" />
            <NuDate formik={formik} name="completion_end_date" label="Completion End Date" width="w-1/2" />
            <NuDate formik={formik} name="reminder_start_date" label="Reminder Start Date" width="w-1/2" />
            <NuDate formik={formik} name="reminder_end_date" label="Reminder End Date" width="w-1/2" />
            <FormikSelectTwo formik={formik} name="status_name" label="Status" width="w-1/2" Options={statusValue} />
          </div>
          <div className="w-full flex items-center px-3 justify-end pb-6 rounded-b">
            <CancelButton onClose={onClose} />
            <SubmitButton />
          </div>
        </form>
      </div>
    </div>
  );
}

export default FilterModal;